<template>
  <div>
    <el-row class="margin-top-lg filter-row">
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" class="filter-col">
        <el-select v-model="simplifyRoomFeeInfo.feeTypeCd" @change="changeSimplifyRoomFeeFeeTypeCd" size="small"
          :placeholder="$t('simplifyRoomFee.selectFeeType')" style="width:100%">
          <template v-for="item in simplifyRoomFeeInfo.feeTypeCds">
            <el-option :key="item.statusCd" :label="item.name" :value="item.statusCd"
              v-if="item.statusCd != '888800010008'"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" class="filter-col">
        <el-select v-model="simplifyRoomFeeInfo.configId" @change="changeSimplifyRoomConfigId" size="small"
          :placeholder="$t('simplifyRoomFee.selectFeeItem')" style="width:100%">
          <el-option v-for="item in simplifyRoomFeeInfo.feeConfigs" :key="item.configId" :label="item.feeName"
            :value="item.configId"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" class="filter-col">
        <el-select v-model="simplifyRoomFeeInfo.state" @change="changeSimplifyRoomConfigId" size="small"
          :placeholder="$t('simplifyRoomFee.selectStatus')" style="width:100%">
          <el-option :label="$t('simplifyRoomFee.valid')" value="2008001"></el-option>
          <el-option :label="$t('simplifyRoomFee.feeEnd')" value="2009001"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" class="filter-col">
        <el-select v-model="simplifyRoomFeeInfo.ownerFee" @change="changeSimplifyRoomConfigId" size="small" style="width:100%">
          <el-option :label="$t('simplifyRoomFee.currentRoom')" value="N"></el-option>
          <el-option :label="$t('simplifyRoomFee.currentOwner')" value="Y"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" class="filter-col" v-if="simplifyRoomFeeInfo.roomId && simplifyRoomFeeInfo.state == '2008001'">
        <el-select v-model="simplifyRoomFeeInfo.showFlag" @change="changeSimplifyRoomShowFlag" size="small" style="width:100%">
          <el-option :label="$t('simplifyRoomFee.default')" value="DEFAULT"></el-option>
          <el-option :label="$t('simplifyRoomFee.monthly')" value="MONTH"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="8" :md="4" :lg="3" :xl="2" v-else class="filter-col"></el-col>
      <el-col :xs="24" :sm="16" :md="20" :lg="15" :xl="14" class="text-right btn-col">
        <el-button type="primary" size="small" v-if="hasPrivilege('502020082314267912')"
          @click="openBatchPayRoomFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.batchPayment') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073007100003')"
          @click="openTempImportRoomFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.tempFee') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073049300004')" @click="openProxyFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.quantityPayment') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073042960005')"
          @click="openAddMeterWaterSimplifyModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.waterElectricity') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073006890006')"
          @click="openRoomCreateFeeComboModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.feePackage') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073096990007')"
          @click="openRoomCreateFeeAddModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.createFee') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502020080570210194')" @click="toOwnerPayFee">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.arrearsPayment') }}
        </el-button>
      </el-col>
    </el-row>

    <div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'DEFAULT'">
      <el-row class="batch-toolbar" v-if="selection.length > 0">
        <el-col :span="24">
          <span class="selected-tip">{{ $t('simplifyRoomFee.selectedCount') }}{{ selection.length }}{{ $t('simplifyRoomFee.items') }}</span>
          <el-button type="danger" size="small" v-if="hasPrivilege('502020090604200029')" @click="batchDeleteFee">
            <i class="el-icon-delete"></i>
            {{ $t('simplifyRoomFee.batchCancelFee') }}
          </el-button>
          <el-button size="small" @click="clearSelection">{{ $t('simplifyRoomFee.clearSelection') }}</el-button>
        </el-col>
      </el-row>
      <!-- 按费用名称分组显示，风格同欠费费用tab -->
      <div v-for="(group, gIdx) in roomFeeGroups" :key="'rfee_' + gIdx" class="fee-group">
        <div class="group-title">{{ group.feeName }}（{{ group.fees.length }}条）</div>
        <el-table :data="group.fees" style="width: 100%" border stripe size="mini" @selection-change="(rows) => onGroupSelectionChange(rows, gIdx)" row-key="feeId">
          <el-table-column type="selection" width="40" :selectable="checkSelectable" />
          <el-table-column :label="$t('simplifyRoomFee.feeType')" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.feeTypeCdName }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('simplifyRoomFee.receivableAmount')" align="center" width="85">
            <template slot-scope="scope">
              {{ getDisplayAmount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('simplifyRoomFee.accountTime')" align="center" width="100">
            <template slot-scope="scope">
              {{ (scope.row.startTime || '').substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('simplifyRoomFee.receivablePeriod')" align="center" min-width="130">
            <template slot-scope="scope">
              {{ getEndTime(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('simplifyRoomFee.description')" align="center" min-width="130">
            <template slot-scope="scope">
              <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                <span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
              </div>
              <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                <span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
              </div>
              <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
              </div>
              <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
              </div>
              <div v-else-if="scope.row.computingFormula == '6006'">
                <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
              </div>
              <div v-else-if="scope.row.computingFormula == '6006'">
                <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
              </div>
              <div v-else-if="scope.row.computingFormula == '6006'">
                <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
              </div>
              <div v-else-if="scope.row.feeTypeCd == '888800010017'">
                <span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
              </div>
              <div v-else-if="scope.row.feeTypeCd == '888800010017'">
                <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
              </div>
              <div v-else>
                <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
              </div>
              <div v-if="scope.row.feeFlag == '1003006'">
                <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
              </div>
              <div v-else>
                <span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="stateName" :label="$t('simplifyRoomFee.status')" align="center" width="80" />
          <el-table-column :label="$t('simplifyRoomFee.operation')" align="center" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="scope.row.state != '2009001' && hasPrivilege('502020082314267912')"
                @click="payFee(scope.row)">
                {{ $t('simplifyRoomFee.payment') }}
              </el-button>
              <el-button type="text" size="small" @click="payFeeHis(scope.row)">
                {{ $t('simplifyRoomFee.paymentHistory') }}
              </el-button>
              <el-dropdown
                v-if="hasPrivilege('502020090604200029') || hasPrivilege('502021070488970005') || hasPrivilege('502020090427190001')">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="hasPrivilege('502020090604200029')" @click.native="deleteFee(scope.row)">
                    {{ $t('simplifyRoomFee.cancelFee') }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="finishFee(scope.row)">
                    {{ $t('simplifyRoomFee.manualEnd') }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.state != '2009001' && hasPrivilege('502020090427190001')"
                    @click.native="editFee(scope.row)">
                    {{ $t('simplifyRoomFee.feeChange') }}
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <a target="_blank" :href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
                      {{ $t('simplifyRoomFee.details') }}
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 无数据提示 -->
      <div v-if="roomFeeGroups.length === 0 && !loading" class="no-data-tip">暂无房屋费用</div>
    </div>

    <div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'MONTH'">
      <el-table :data="simplifyRoomFeeInfo.monthFees" style="width: 100%" border stripe>
        <el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center" width="150">
          <template slot-scope="scope">
            <span class="hand" @click="viewRoomFeeConfig(scope.row)">
              {{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.chargeYearMonth')" align="center">
          <template slot-scope="scope">
            {{ scope.row.detailYear }}-{{ scope.row.detailMonth }}
          </template>
        </el-table-column>
        <el-table-column prop="receivableAmount" :label="$t('simplifyRoomFee.receivableAmount')"
          align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-if="scope.row.feeFlag == '1003006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.operation')" align="center">
          <template slot-scope="scope">
            <a target="_blank" :href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
              {{ $t('simplifyRoomFee.details') }}
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleMonthCurrentChange" :current-page="monthCurrentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="monthTotal" class="pagination text-right"></el-pagination>
    </div>

    <el-row>
      <el-col :span="12" class="text-left table-desc">
        <div>{{ $t('simplifyRoomFee.note1') }}</div>
        <div>{{ $t('simplifyRoomFee.note2') }}</div>
      </el-col>
      <el-col :span="6">
        <span>
          <span>{{ $t('simplifyRoomFee.arrearsSubtotal') }}</span>{{ simplifyRoomFeeInfo.totalAmount }}
        </span>
      </el-col>
    </el-row>
    <!-- Modal Components -->
    <delete-fee ref="deleteFee" @success="handleNotify"></delete-fee>
    <edit-fee ref="editFee" @success="handleNotify"></edit-fee>
    <temp-import-room-fee ref="tempImportRoomFee" @success="handleNotify"></temp-import-room-fee>
    <room-create-fee-add ref="roomCreateFeeAdd" @success="handleNotify"></room-create-fee-add>
    <add-meter-water ref="addMeterWater" @success="handleNotify"></add-meter-water>
    <add-proxy-fee ref="addProxyFee" @success="handleNotify"></add-proxy-fee>
    <finish-fee ref="finishFee" @success="handleNotify"></finish-fee>
  </div>
</template>

<script>
import { listFee, listFeeConfigs, listMonthFee } from '@/api/fee/simplifyRoomFeeApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import { deleteFee } from '@/api/fee/deleteFeeApi'
//import { listFeeConfigs } from '@/api/fee/feeConfigManageApi'
import TempImportRoomFee from './tempImportRoomFee'
import { dateFormat } from '@/utils/dateUtil'
import DeleteFee from '@/components/fee/deleteFee'
import EditFee from '@/components/fee/editFee'
import RoomCreateFeeAdd from '@/components/fee/roomCreateFeeAdd'
import AddMeterWater from '@/components/fee/addMeterWater'
import AddProxyFee from '@/components/fee/addProxyFee'
import FinishFee from '@/components/fee/finishFee'

export default {
  name: 'SimplifyRoomFee',
  components: {
    TempImportRoomFee,
    DeleteFee,
    EditFee,
    RoomCreateFeeAdd,
    AddMeterWater,
    AddProxyFee,
    FinishFee
  },
  data() {
    return {
      simplifyRoomFeeInfo: {
        total: 0,
        records: 1,
        fees: [],
        monthFees: [],
        roomId: '',
        roomName: '',
        name: '',
        floorNum: '',
        unitNum: '',
        roomNum: '',
        configId: '',
        feeTypeCds: [],
        feeTypeCd: '',
        state: '2008001',
        totalAmount: 0.0,
        roomType: '',
        ownerFee: 'N',
        ownerId: '',
        showFlag: 'DEFAULT',
        feeConfigs: []
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      monthCurrentPage: 1,
      monthTotal: 0,
      selection: [], // 多选选中的费用项
      loading: false,
      groupSelections: {} // 按表格分组追踪选中项
    }
  },
  computed: {
    filteredFeeTypeCds() {
      return this.simplifyRoomFeeInfo.feeTypeCds.filter(item => item.statusCd !== '888800010008')
    },
    // 按费用名称分组，费用名称内按 startTime 升序
    roomFeeGroups() {
      const map = {}
      this.simplifyRoomFeeInfo.fees.forEach(fee => {
        const key = fee.feeName || '其他费用'
        if (!map[key]) map[key] = []
        map[key].push(fee)
      })
      const result = Object.keys(map).map(name => {
        map[name].sort((a, b) => {
          const tA = a.startTime ? new Date(a.startTime).getTime() : 0
          const tB = b.startTime ? new Date(b.startTime).getTime() : 0
          return tA - tB
        })
        return { feeName: name, fees: map[name] }
      })
      return result
    }
  },
  created() {
    this.communityId = getCommunityId()
    //this.loadDictData()
  },
  methods: {
    open(params) {
      this.handleSwitch(params)
    },
    handleSwitch(param) {
      this.clearSimplifyRoomFeeInfo()
      if (param.roomId === '') return

      Object.assign(this.simplifyRoomFeeInfo, param)
      this.listSimplifyRoomFee()

      getDict('pay_fee_config', 'fee_type_cd').then(data => {
        this.simplifyRoomFeeInfo.feeTypeCds = data
      })
    },
    handleNotify() {
      this.listSimplifyRoomFee()
    },
    getOnePrice1(fee) {
      let price = fee.mwPrice
      if (!price) return fee.squarePrice
      if (parseFloat(price) > 0) return price
      return fee.squarePrice
    },
    async listSimplifyRoomFee() {
      const params = {
        page: 1,
        row: 500,
        communityId: getCommunityId(),
        payerObjId: this.simplifyRoomFeeInfo.roomId,
        payerObjType: '3333',
        configId: this.simplifyRoomFeeInfo.configId,
        state: this.simplifyRoomFeeInfo.state,
        feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd
      }

      if (this.simplifyRoomFeeInfo.ownerFee === 'Y') {
        params.payerObjId = ''
        params.ownerId = this.simplifyRoomFeeInfo.ownerId
      }

      try {
        this.loading = true
        // 按收费开始时间升序排列
        params.orderBy = 'start_time'
        const res = await listFee(params)
        this.simplifyRoomFeeInfo.total = res.total
        this.simplifyRoomFeeInfo.records = res.records

        // 优先使用后端返回的全量合计，否则用当前页汇总
        if (res.totalAmount !== undefined && res.totalAmount !== null) {
          this.simplifyRoomFeeInfo.totalAmount = parseFloat(res.totalAmount).toFixed(2)
        } else {
          let totalAmount = 0.0
          res.fees.forEach(item => {
            totalAmount += parseFloat(item.amount)
          })
          this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
        }

        this.simplifyRoomFeeInfo.fees = res.fees
        this.total = res.total
      } catch (error) {
        console.error('Failed to fetch fee list:', error)
      } finally {
        this.loading = false
      }
    },
    // 跨表格分组多选
    onGroupSelectionChange(rows, groupKey) {
      if (!this.groupSelections) this.groupSelections = {}
      this.groupSelections[groupKey] = rows
      clearTimeout(this.mergeTimer)
      this.mergeTimer = setTimeout(() => {
        const merged = []
        Object.values(this.groupSelections).forEach(groupRows => {
          groupRows.forEach(f => merged.push(f))
        })
        this.selection = merged
      }, 30)
    },
    roomFeeCompare(a, b) {
      const timeA = new Date(a.startTime).getTime()
      const timeB = new Date(b.startTime).getTime()
      if (timeA < timeB) return -1
      if (timeA > timeB) return 1
      return 0
    },
    getDisplayAmount(fee) {
      // 有实际欠费金额时显示欠费金额
      if (fee.amountOwed && parseFloat(fee.amountOwed) > 0) {
        return parseFloat(fee.amountOwed).toFixed(2)
      }
      // 未到收费时间，显示单周期应收金额
      if (fee.feeTotalPrice && parseFloat(fee.feeTotalPrice) > 0) {
        return parseFloat(fee.feeTotalPrice).toFixed(2)
      }
      // fallback
      return fee.amount || 0
    },
    toOwnerPayFee() {
      this.$router.push({
        path: '/views/fee/owePayFeeOrder',
        query: {
          payObjId: this.simplifyRoomFeeInfo.roomId,
          payObjType: '3333',
          roomName: this.simplifyRoomFeeInfo.roomName
        }
      })
    },
    openRoomCreateFeeAddModal() {
      this.simplifyRoomFeeInfo.ownerName = this.simplifyRoomFeeInfo.name
      this.$refs.roomCreateFeeAdd.open({
        isMore: false,
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    openAddMeterWaterSimplifyModal() {
      this.$refs.addMeterWater.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      });
    },
    getAttrValue(attrs, specCd) {
      const attr = attrs.find(item => item.specCd === specCd)
      return attr ? attr.value : ""
    },
    getDeadlineTime(fee) {
      if (fee.amountOwed === 0 && fee.endTime === fee.deadlineTime) return "-"
      if (fee.state === '2009001') return "-"
      return dateFormat(fee.deadlineTime)
    },
    getEndTime(fee) {
      if (fee.state === '2009001') return "-"
      const startTime = dateFormat(fee.startTime)
      // 一次性费用 startTime=endTime，用 deadlineTime 作为范围终点
      const start = new Date(fee.startTime).getTime()
      const end = new Date(fee.endTime).getTime()
      let displayEnd
      if (start === end || !fee.endTime) {
        displayEnd = fee.deadlineTime ? dateFormat(fee.deadlineTime) : startTime
      } else {
        displayEnd = dateFormat(fee.endTime)
      }
      return startTime + '~' + displayEnd
    },
    openProxyFeeModal() {
      this.$refs.addProxyFee.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    payFee(fee) {
      fee.roomName = this.simplifyRoomFeeInfo.roomName
      fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
      this.$router.push({
        path: '/views/fee/payFeeOrder',
        query: { feeId: fee.feeId, ownerId: this.simplifyRoomFeeInfo.ownerId || this.simplifyRoomFeeInfo.roomId || '' }
      })
    },
    editFee(fee) {
      fee.maxEndTime = this.getAttrValue(fee.feeAttrs, '390010')
      this.$refs.editFee.open(fee)
    },
    payFeeHis(fee) {
      fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
      this.$router.push({
        path: '/views/fee/propertyFee',
        query: fee
      })
    },
    deleteFee(fee) {
      this.$refs.deleteFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    finishFee(fee) {  
      this.$refs.finishFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    openTempImportRoomFeeModal() {
      this.$refs.tempImportRoomFee.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    checkSelectable(row) {
      // 已结束的费用不可选
      return row.state !== '2009001'
    },
    clearSelection() {
      this.groupSelections = {}
      this.selection = []
    },
    batchDeleteFee() {
      if (this.selection.length === 0) {
        this.$message.warning(this.$t('simplifyRoomFee.selectFeeFirst'))
        return
      }
      const confirmMsg = this.$t('simplifyRoomFee.batchCancelConfirm').replace('{count}', this.selection.length)
      this.$confirm(
        confirmMsg,
        this.$t('deleteFee.title'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.doBatchDeleteFee()
      }).catch(() => { })
    },
    async doBatchDeleteFee() {
      const communityId = getCommunityId()
      const feeIds = this.selection.map(item => item.feeId)
      let successCount = 0
      let failCount = 0

      const loading = this.$loading({
        lock: true,
        text: this.$t('simplifyRoomFee.deleting') || '正在批量取消费用...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        for (const feeId of feeIds) {
          try {
            const res = await deleteFee({ communityId, feeId })
            if (res.code === 0) {
              successCount++
            } else {
              failCount++
            }
          } catch (err) {
            failCount++
          }
        }
        loading.close()

        if (successCount > 0) {
          const msg = this.$t('simplifyRoomFee.batchCancelSuccess').replace('{count}', successCount)
          this.$message.success(msg)
        }
        if (failCount > 0) {
          const msg = this.$t('simplifyRoomFee.batchCancelFail').replace('{count}', failCount)
          this.$message.warning(msg)
        }
        // 刷新列表
        this.handleNotify()
      } catch (error) {
        loading.close()
        console.error('批量取消费用失败:', error)
      }
    },
    clearSimplifyRoomFeeInfo() {
      const feeConfigs = this.simplifyRoomFeeInfo.feeConfigs
      this.simplifyRoomFeeInfo = {
        total: 0,
        records: 1,
        fees: [],
        monthFees: [],
        accounts: [],
        roomId: '',
        name: '',
        roomName: '',
        floorNum: '',
        unitNum: '',
        roomNum: '',
        feeConfigs: feeConfigs,
        feeTypeCd: '',
        configId: '',
        state: '2008001',
        totalAmount: 0.0,
        roomType: '',
        ownerFee: 'N',
        ownerId: '',
        showFlag: 'DEFAULT'
      }
    },
    changeSimplifyRoomFeeFeeTypeCd(feeTypeCd) {
      this.simplifyRoomFeeInfo.configId = ''
      this.$emit('notify', {})

      const params = {
        page: 1,
        row: 50,
        communityId: getCommunityId(),
        feeTypeCd: feeTypeCd,
        isDefault: '',
        valid: '1'
      }

      listFeeConfigs(params).then(res => {
        this.simplifyRoomFeeInfo.feeConfigs = res.feeConfigs
      }).catch(error => {
        console.error('Failed to fetch fee configs:', error)
      })
    },
    changeSimplifyRoomConfigId() {
      this.handleNotify()
      this.$emit('notify', {})
    },
    simplifyRoomGetFeeOwnerInfo(attrs) {
      const ownerName = this.getAttrValue(attrs, '390008')
      const ownerLink = this.getAttrValue(attrs, '390009')
      return `业主：${ownerName},电话：${ownerLink}`
    },
    getSimplifyRoomFeeRoomName(fee) {
      if (this.simplifyRoomFeeInfo.ownerFee != 'Y') return ''

      const attr = fee.feeAttrs.find(item => item.specCd === '390012')
      return attr ? `(${attr.value})` : ''
    },
    openBatchPayRoomFeeModal() {
      this.$router.push({
        path: '/views/fee/batchPayFeeOrder',
        query: {
          ownerId: this.simplifyRoomFeeInfo.ownerId,
          payerObjType: '3333'
        }
      })
    },
    openMonthPayRoomFeeModal() {
      this.$router.push({
        path: '/property/payFeeMonthOrder',
        query: {
          payerObjId: this.simplifyRoomFeeInfo.roomId,
          payerObjType: '3333'
        }
      })
    },
    openRoomCreateFeeComboModal() {
      this.$router.push({
        path: '/views/fee/createFeeByCombo',
        query: {
          payerObjId: this.simplifyRoomFeeInfo.roomId,
          payerObjName: this.simplifyRoomFeeInfo.roomName,
          payerObjType: '3333'
        }
      })
    },
    viewRoomFeeConfig(fee) {
      const params = {
        page: 1,
        row: 1,
        communityId: getCommunityId(),
        configId: fee.configId
      }

      listFeeConfigs(params).then(res => {
        const feeConfig = res.feeConfigs[0]
        this.$emit('openViewDataModal', {
          title: `${fee.feeName} 费用项`,
          data: {
            "费用项ID": feeConfig.configId,
            "费用类型": feeConfig.feeTypeCdName,
            "收费项目": feeConfig.feeName,
            "费用标识": feeConfig.feeFlagName,
            "催缴类型": feeConfig.billTypeName,
            "付费类型": feeConfig.paymentCd == '1200' ? '预付费' : '后付费',
            "缴费周期": feeConfig.paymentCycle,
            "应收开始时间": feeConfig.startTime,
            "应收结束时间": feeConfig.endTime,
            "公式": feeConfig.computingFormulaName,
            "计费单价": feeConfig.computingFormula == '2002' ? '-' : feeConfig.squarePrice,
            "附加/固定费用": feeConfig.additionalAmount
          }
        })
      }).catch(error => {
        console.error('Failed to fetch fee config:', error)
      })
    },
    viewRoomFee(fee) {
      const data = {
        "费用ID": fee.feeId,
        "费用标识": fee.feeFlagName,
        "费用类型": fee.feeTypeCdName,
        "付费对象": fee.payerObjName,
        "费用项": fee.feeName,
        "费用状态": fee.stateName,
        "建账时间": fee.startTime,
        "应收开始时间": fee.startTime,
        "应收结束时间": fee.endTime,
        "批次": fee.batchId
      }

      fee.feeAttrs.forEach(attr => {
        data[attr.specCdName] = attr.value
      })

      this.$emit('openViewDataModal', {
        title: `${fee.feeName} 详情`,
        data: data
      })
    },
    changeSimplifyRoomShowFlag() {
      if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
        this.listSimplifyRoomMonthFee(1, this.pageSize)
      } else {
        this.listSimplifyRoomFee()
      }
    },
    async listSimplifyRoomMonthFee(page, row) {
      const params = {
        page,
        row,
        communityId: getCommunityId(),
        objId: this.simplifyRoomFeeInfo.roomId,
        payerObjType: '3333',
        configId: this.simplifyRoomFeeInfo.configId,
        feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd,
        detailId: '-1',
        feeState: '2008001'
      }

      if (this.simplifyRoomFeeInfo.ownerFee == 'Y') {
        params.payerObjId = ''
        params.ownerId = this.simplifyRoomFeeInfo.ownerId
      }

      try {
        const res = await listMonthFee(params)
        this.simplifyRoomFeeInfo.total = res.total
        this.simplifyRoomFeeInfo.records = res.records

        // 优先使用后端返回的全量合计
        if (res.sumTotal !== undefined && res.sumTotal !== null) {
          this.simplifyRoomFeeInfo.totalAmount = parseFloat(res.sumTotal).toFixed(2)
        } else {
          let totalAmount = 0.0
          res.data.forEach(item => {
            totalAmount += parseFloat(item.receivableAmount)
          })
          this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
        }

        this.simplifyRoomFeeInfo.monthFees = res.data
        this.monthTotal = res.total
      } catch (error) {
        console.error('Failed to fetch month fee list:', error)
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page
      if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
        this.monthCurrentPage = page
        this.listSimplifyRoomMonthFee(page, this.pageSize)
      }
    },
    handleMonthCurrentChange(page) {
      this.monthCurrentPage = page
      this.listSimplifyRoomMonthFee(page, this.pageSize)
    },
    // 其他方法类似
  }
}
</script>

<style scoped>
.margin-top-lg {
  margin-top: 20px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}

.hand {
  cursor: pointer;
}

.filter-row {
  flex-wrap: wrap;
}

.filter-col {
  margin-bottom: 8px;
}

.btn-col {
  margin-bottom: 8px;
}

.batch-toolbar {
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
}

.batch-toolbar .selected-tip {
  color: #f56c6c;
  font-size: 14px;
  margin-right: 15px;
  font-weight: 500;
}

/* 分组表格样式，对齐欠费费用tab */
.fee-group {
  margin-bottom: 10px;
}

.group-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  padding: 6px 0;
  margin-bottom: 2px;
  border-bottom: 2px solid #409EFF;
}

.no-data-tip {
  text-align: center;
  color: #909399;
  padding: 30px 0;
  font-size: 13px;
}
</style>